import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMobileOrientation } from 'react-device-detect';
import Box from '@mui/material/Box';
import '../../style/HangManQuestion.css';
import { setSelectedRound } from '../../Redux/action';
import { useNavigate } from 'react-router-dom'; 
import BasicQuestionHeader from '../../Header/BasicQuestionHeader';
import landscapeIcon from '../../image/landscape-icon.webp';

const HangManQuestion = ({ onNavigate }) => {
  const dispatch = useDispatch();
  const { orientation } = useMobileOrientation();
  const navigate = useNavigate();
  const selectedRound = useSelector((state) => state.round.selectedRound);
  const backgroundColor = useSelector(state => state.backgroundColor.backgroundColor);
  const fontColor = useSelector(state => state.fontColor.fontColor);
  const teamNames = useSelector(state => state.gameSettings.teamNames);
  const team1bgColor = useSelector(state => state.gameSettings.team1bgColor);
  const team2bgColor = useSelector(state => state.gameSettings.team2bgColor);
  const buttonColor = useSelector(state => state.gameSettings.buttonColor);
  const [fontSize, setFontSize] = useState('5vw'); // Default font size using viewport width
  const backgroundImg = useSelector(state => state.backgroundImg.backgroundImg);
  const [isportrait,setIsportrait] = useState(false);
  const mobile = useSelector(state => state.mobile.isMobile);

  const backgroundStyle = backgroundImg
  ? {
      backgroundImage: `url(${backgroundImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    }
  : {
      backgroundColor,
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    };
  
  const questionRef = useRef(null);



  useEffect(() => {
    const savedRound = localStorage.getItem('selectedRound');
    if (savedRound) {
      dispatch(setSelectedRound(JSON.parse(savedRound)));
    }
  }, [dispatch]);

  useEffect(() => {
    const adjustFontSize = () => {
      const viewportWidth = window.innerWidth;
      const questionLength = questionRef.current ? questionRef.current.textContent.length : 0;
      
      let size = '120px'; // Default font size

      if (questionLength > 100) {
        size = '50px';
      } else if (questionLength > 50) {
        size = '70px';
      }

      // Adjust based on viewport width
      if (viewportWidth <= 1024) {
        size = `${parseInt(size, 10) / 2}px`; // Halve the font size
      }
      if (viewportWidth <= 765) {
        size = `${parseInt(size, 10) / 2}px`; // Further halve the font size
      }

      setFontSize(size);
    };

    adjustFontSize(); // Call the function to adjust font size on component mount

    window.addEventListener('resize', adjustFontSize); // Adjust font size on window resize

    return () => {
      window.removeEventListener('resize', adjustFontSize); // Cleanup listener on unmount
    };
  }, [selectedRound]);

  const handleClick = () => {
    if (selectedRound && selectedRound.answer) {
      const upperCaseAnswer = selectedRound.answer.toUpperCase(); // Convert to uppercase
      localStorage.setItem('wordToGuess', upperCaseAnswer); // Save the word to guess in local storage
      onNavigate('playscreen'); // Navigate to the play screen
    }
  };
  useEffect(() => {
    if (orientation === 'portrait') {
      // User is on a mobile device in portrait mode
      setIsportrait(true);
      console.log("Mobile portrait mode detected");
    } else {
      setIsportrait(false);
      console.log("Not mobile portrait mode");
    }
  }, [orientation]);


  return (
    <>
      {isportrait ? (
          <>
        <div 
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '1.5rem',
            fontWeight:'bolder',
            backgroundColor:'#27738e',
            color: 'white',
            display:'flex',
            flexDirection:'column',
            padding: '1.5vh'
          }}
        >
          <span className='mt-2 mb-4 p-3 '> To view this game, you will need to place your device in landscape mode</span>

          <div style={{padding:'1.5vh'}}>
          <img src={landscapeIcon} alt="landscapeIcon" height={200} className="rotate-icon" />
          </div>
        </div>
        </>
      ):
       (
        <>
      <BasicQuestionHeader onNavigate={onNavigate} />
      <div className="hangman-container" style={backgroundStyle}>
        <Box
          className="hangman-box-question"
          onClick={handleClick}
          style={{ backgroundColor: buttonColor }}
        >
          <span
            className="questionText"
            style={{ color: fontColor, fontSize: fontSize }}
            ref={questionRef}
          >
            {selectedRound ? selectedRound.question : 'No question available.'}
          </span>
        </Box>
      </div>
      </>
        )
  }
    </>
  );
};

export default HangManQuestion;
